import { COMPILER_ERROR_TYPES } from "@imminently/decisively-core";
import DetailVerticalList from "../../common/DetailVerticalList/DetailVerticalList";
import styles from "./ExpressionErrors.module.scss";
import clsx from "clsx";

export interface ExpressionErrorsProps {
  className?: string;
  expression?: { errors?: Array<{ message?: string; type?: string } | null | undefined> } | null;
  errors?: Array<{ message?: string; type?: string } | null | undefined>;
}

const ExpressionErrors = (props: ExpressionErrorsProps) => {
  const { expression, errors = [], className, ...otherProps } = props;
  const combined = [...(expression?.errors || []), ...errors];
  const filtered = combined.filter(Boolean) as Array<{ message?: string; type?: string }>;
  if (!filtered.length) return null;

  const errorTypeDisplayById = Object.fromEntries(
    Object.values(COMPILER_ERROR_TYPES).map((info) => [info.id, info.displayName]),
  ) as Record<string, string>;

  return (
    <DetailVerticalList className={ clsx(className, styles.expressionErrors)} {...otherProps}>

      {filtered.map((error, index) => (
        <DetailVerticalList.Item key={index}>
          <DetailVerticalList.Title>{(error.type && errorTypeDisplayById[error.type]) || error.type || "Error"}</DetailVerticalList.Title>
          <DetailVerticalList.Content>{error.message || "Unknown error"}</DetailVerticalList.Content>
        </DetailVerticalList.Item>
      ))}
    </DetailVerticalList>
  );
};

export default ExpressionErrors;
